export default require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../scss/_variables.scss');